import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import { Button, CancelButton, ButtonBar } from '../components/Button.jsx';
import { color } from '../theme';

const HeroText = styled.h1`
  text-align: center;
  font-size: 32px;
  font-weight: normal;
`;

const HeroWrapper = styled.div`
  min-height: 250px;
  font-size: 32px;
  color: white;

  padding: 20px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background: linear-gradient(${color(3)}, ${color(1)});
  box-shadow: 0 4px 11px rgba(124, 146, 169, 0.5);
`;

export const Bar = styled(ButtonBar)`
  display: flex;
  justify-content: flex-end;

  & > *:not(:last-child) {
    margin-right: 10px;
  }

  margin-top: 40px;
  font-size: 24px;
  color: white;
`;

export const AppButton = styled(CancelButton)`
  fill: white;
  color: white;

  &:hover {
    fill: white;
    color: white;
  }
`;

export default ({ openApp, learnMore, children }) => (
  <HeroWrapper>
    <HeroText>{children}</HeroText>
    <Bar>
      <AppButton as="a" href="https://app.horair.es" target="_blank" rel="noopener noreferrer">
        {openApp}
      </AppButton>
      <Button as="a" href="#more-info">
        {learnMore}
      </Button>
    </Bar>
  </HeroWrapper>
);
